export default function getSubscription() {
    return Promise.resolve('serviceWorker' in navigator).then(browserSupportsServiceWorkers => {
        return browserSupportsServiceWorkers
            ? navigator.serviceWorker.ready.then(registration =>
                  registration.pushManager.getSubscription()
              )
            : null;
    });
}
